export const environment = {
  production: true,
  //apiUrl: "http://localhost:80/SwiftBackendAPI/api/",
  apiUrl: '/SwiftBackendAPI/api/',
  rptUrl: 'https://app.labportal.vet/',
  cloudApiUrl: '/SwiftBackendAPI/api/',
  lunitApiUrl: '/',
  imageUrl: '/SwiftBackendAPI/api/ImageUpload/',
  profileImagerUrl: '/Documents/',
  documentEnvURL: '/Documents/',
  reportQRCodeURL: 'https://app.labportal.vet/Documents/',
  reportingImgEnvURL: '/Documents/OrderImagePath/',
  //reportingImgEnvURL: "/Documents/StudyKeyImages/",
  selectedApiUrl: '/SwiftBackendAPI/api/',
  isCloud: true,
  isSuperAdmin: false,
  isSiteAdmin: false,
  isSkipLocation: true,
  excelTemplatePath: '../../assets/Documents/Templates/',
  reportViewerUrl: '/ReportsViewer/',
  appUrl: 'https://doc.dinsight.health/#/',
  refreashTimeinSec: 300000,
  OAuthUrl:
    'access.line.me/oauth2/v2.1/login?loginState=Ir5DviW235jbc55TMqTvCG&loginChannelId=1661352421&returnUri=%2Foauth2%2Fv2.1%2Fauthorize%2Fconsent%3Fresponse_type%3Dcode%26client_id%3D1661352421%26redirect_uri%3Dhttps%3A%2F%2Fapp.vetportal.vet%2FLineOAuth%26state%3D12345abcde%26scope%3Dprofile%2Bopenid%2Bemail%26nonce%3D09876xyz%26bot_prompt%3Daggressive#/',
  defaultRadiologistImage: '../assets/layout/images/topbar/avatar.png',
  defaultReportHeaderImage: '../assets/layout/images/topbar/reportheader.png',
  studyListAutorefreashTenSec: 10000,
};
